import React from 'react';
import PropTypes from 'prop-types';

import styles from './MainList.css';

import MainItem from './MainItem';

const MainList = ({ activeItem, navItems }) => (
  <ul className={styles.main}>
    {navItems.map(item => (
      <MainItem meta={item} key={item.key} isActive={item.key === activeItem} />
    ))}
  </ul>
);

MainList.displaName = 'MainList';

MainList.propTypes = {
  activeItem: PropTypes.string,
  navItems: PropTypes.array.isRequired,
};

export default MainList;
